import styled from "styled-components";
import { isMobile } from "react-device-detect";

export const StyledModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background: white;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: ${({ maxWidth }) => maxWidth || '975px'};
  min-height: ${({ minHeight }) => minHeight || '450px'};
  max-height: 90vh;
  overflow: hidden;
  overflow-y: auto;
`;

export const ModalHeader = styled.h3`
  margin-top: 0;
  color: #333;
  text-align: center;
`;

export const ModalBody = styled.div`
  margin: 20px 0;
`;

export const ModalFooter = styled.div`
  text-align: right;
`;